import type { Context, Plugin } from '@segment/analytics-next';

import type { CustomContext } from '../types/context/customContext';

// A Segment `before` plugin that stamps shared context (surface, session, and any app-supplied
// fields) onto every outgoing event, so call sites never repeat it. `enrichContext` merges (does not
// replace) fields into the internal context; the per-type handlers spread that context into
// each event's `context` object. Matches mobile: the shared context always wins over whatever is
// already on the event's `context`.
export function createContextEnrichmentPlugin(initialContext: CustomContext): {
  plugin: Plugin;
  enrichContext: (partial: Partial<CustomContext>) => void;
} {
  let context: CustomContext = { ...initialContext };

  const enrichContext = (partial: Partial<CustomContext>) => {
    context = { ...context, ...partial };
  };

  const apply = (ctx: Context): Context => {
    const existing = (ctx.event.context ?? {}) as Record<string, unknown>;
    ctx.updateEvent('context', { ...existing, ...context });
    return ctx;
  };

  const plugin: Plugin = {
    name: 'Redcat Context Enrichment',
    type: 'before',
    version: '1.0.0',
    isLoaded: () => true,
    load: () => Promise.resolve(),
    track: apply,
    identify: apply,
    page: apply,
    group: apply,
    alias: apply,
  };

  return { plugin, enrichContext };
}
